module.exports = __webpack_public_path__ + "static/media/04(5).fe403986.jpg";